export const company = {
  productName: 'Bookstera',
  legalName: 'Division by Heroes e.U.',
  companyNumber: 'FN 506683y',
  vatNumber: 'ATU65007137',
  streetAddress: 'Liniengasse 48/22',
  postalCode: '1060',
  city: 'Vienna',
  country: 'Austria',
  founder: 'Andreas Braumann',
  founderImage: '/images/andreas-braumann.jpg',
  supportEmail: 'support@bookstera.com',
  websiteUrl: 'https://www.bookstera.com',
  urls: {
    about: '/about', successStories: '/success-stories', reviews: '/reviews',
    trustpilot: 'https://www.trustpilot.com/review/bookstera.com',
    productHunt: 'https://www.producthunt.com/products/bookster-cc-ideas-to-ebooks-in-minutes',
    imprint: '/imprint', privacy: '/privacy-policy', terms: '/terms',
    refundPolicy: '/terms#withdrawal-and-refunds', support: '/support', pricing: '/pricing',
  },
  // Intentionally absent until backed by a maintained source.
  metrics: {} as { customers?: number; booksCreated?: number; trustpilotRating?: number; trustpilotReviewCount?: number },
} as const;

export const organizationSchema = {
  '@type': 'Organization', '@id': `${company.websiteUrl}/#organization`,
  name: company.productName, legalName: company.legalName, url: `${company.websiteUrl}/`,
  description: 'Bookstera is an AI-assisted book creation, design, publishing, export, and lead-funnel platform for authors and creators.',
  logo: `${company.websiteUrl}/lovable-uploads/bookstera-logo-nobg.webp`,
  founder: { '@id': `${company.websiteUrl}${company.urls.about}#founder` },
  address: { '@type': 'PostalAddress', streetAddress: company.streetAddress, postalCode: company.postalCode, addressLocality: company.city, addressCountry: 'AT' },
  email: company.supportEmail,
  vatID: company.vatNumber,
  identifier: company.companyNumber,
  contactPoint: { '@type': 'ContactPoint', email: company.supportEmail, contactType: 'customer support', url: `${company.websiteUrl}${company.urls.support}` },
  knowsAbout: ['AI-assisted book creation', 'ebook design', 'ebook publishing', 'publishing exports', 'lead funnels'],
  sameAs: [company.urls.trustpilot, company.urls.productHunt],
};

export const founderSchema = {
  '@type': 'Person',
  '@id': `${company.websiteUrl}${company.urls.about}#founder`,
  name: company.founder,
  url: `${company.websiteUrl}${company.urls.about}`,
  image: `${company.websiteUrl}${company.founderImage}`,
  jobTitle: 'Founder of Bookstera',
  worksFor: { '@id': `${company.websiteUrl}/#organization` },
};
